module.exports = __webpack_public_path__ + "static/media/brand-logo.2ebe96ad.svg";